import { useIntl } from "react-intl";

export default function RequiresFullAccessHint({ hasFullAccess, children }) {
  const intl = useIntl();
  if (hasFullAccess) {
    return children;
  }
  return (
    <span
      className="d-inline-block"
      title={intl.formatMessage({ id: "RequiresFullTeacherAccess" })}
    >
      {children}
    </span>
  );
}
